var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    stroke: "#717171",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04999,
    cy: 12.0498,
    r: 1.25,
    fill: "#717171"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.05,
    cy: 12.0498,
    r: 1.25,
    fill: "#717171"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.05,
    cy: 12.0498,
    r: 1.25,
    fill: "#717171"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/more-circle.17480a5f8092e70dc7b8a372fd540fae.svg";